import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { useDispatch, useSelector } from "react-redux";
import {
  cancelSubscription,
  checkSubscriptionStatus,
  getPlans,
  subcriptionSession,
} from "../../redux/actions/subscription";
import { centsToDollar, formatTime } from "../../constants/base";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { updateUser } from "../../redux/slices/authSlice";
import { toast } from "react-toastify";
import { getAuthUser } from "../../redux/actions/user";
import SubscriptionTable from "../SubscriptionTable/SubscriptionTable";

const stripePromise = loadStripe(
  "pk_test_51TfRLQHwRXEwrlmzdF2UORiAqhodVRD0QQajKL2ydILRxfb8hr8tmgHW8grzWIpFJ3qfDUlloPmyIy3fOQGjDrlc00SoCGmfDj"
);

const Subscription = ({ role }) => {
  const authUser = useSelector((state) => state.AuthSlice.user);
  const user = useSelector((state) => state.user.user);
  const plans = useSelector((state) => state.subscriptions);
  const subscriptionStatus = useSelector(
    (state) => state?.subscriptions?.subscriptionStatus
  );
  const [selectedPlan, setSelectedPlan] = useState("");
  const [showModelData, setShowModelData] = useState(false);

  const [loadingPlanId, setLoadingPlanId] = useState(null);

  const currentDate = new Date();
  const subscriptionEndDate = new Date(user?.subscription?.end_date);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (authUser?.id) {
      dispatch(getAuthUser(authUser?.id));
    }
  }, [authUser?.id]);


  const handleCheckout = async (id, interval) => {

    setLoadingPlanId(id);

    const data = {
      user_id: user?.id,
      price_id: id,
      customer_email: user?.email,
      type: interval,
      url: location.pathname,
    };

    const response = await dispatch(subcriptionSession(data));
    const stripe = await stripePromise;
    const { error } = await stripe.redirectToCheckout({
      sessionId: response.payload.data.data.session_id,
    });

    if (error) {
      console.error(error);
    }
  };

  // SUBSCRIPTION STATUS
  const checkSubscriptionStatusFunction = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get("session_id");

    if (sessionId) {
      const data = {
        session_id: sessionId,
      };
      const res = await dispatch(checkSubscriptionStatus(data));
      if (checkSubscriptionStatus.fulfilled(res)) {
        const storeRes = dispatch(updateUser(res?.payload?.data?.data));
        navigate("/payment/success");
      } else if (checkSubscriptionStatus.rejected(res)) {
        navigate("/payment/error");
      }
    }
  };

  useEffect(() => {
    checkSubscriptionStatusFunction();
  }, []);
  // SUBSCRIPTION STATUS

  const getPlansHandler = async (role) => {
    if (role) {
      await dispatch(getPlans(role));
    }
  };

  useEffect(() => {
    if (role) {
      getPlansHandler(role);
    }
  }, [role]);

  if (plans?.loading) {
    return (
      <div className="text-center">
        <i
          style={{ fontSize: "22px" }}
          className="fa-solid fa-spinner fa-spin"
        ></i>
      </div>
    );
  }

  // CANCEL SUBSCRIPTION HERE
  const handleCancelSubscription = async () => {
    const data = {
      subscription_id: user?.subscription?.stripe_subscription_id,
    };
    const res = await dispatch(cancelSubscription(data));

    if (cancelSubscription.fulfilled(res)) {
      toast.success("Subscription has been cancelled!");
      window.location.reload();
    } else if (cancelSubscription.rejected(res)) {
      toast.error("Something went wrong to cancel the subscription!!");
      window.location.reload();
    }

    // if (res?.payload?.status === 200) {
    //   // const storeRes = dispatch(updateUser(res?.payload?.data?.data))
    // } else {
    //   toast.error("there is an error to cancel the subscription");
    // }
  };
  // CANCEL SUBSCRIPTION HERE

  return (
    <>
      <div>
        <div className="subscripiton-plans-box">
          <div className="container">
            <div className="row">
              <div
                className={`col-md-4 mb-4 ${user?.subscription?.type === "free" ? "currentPlan-box" : ""
                  } ${user?.subscription?.type === "free" &&
                    subscriptionEndDate < currentDate
                    ? "show-disable-card"
                    : ""
                  } ${user?.subscription?.type !== "free" ? "show-disable-card" : ""
                  }`}
              >
                <div className={`subscription-card`}>
                  <h1>
                    30 Days{" "}
                    {user?.subscription?.type === "free" &&
                      subscriptionEndDate < currentDate
                      ? "(Free Trial Expired)"
                      : ""}
                  </h1>
                  <span>Free Trial</span>
                  <p>
                    Thank you for your interest in I-Sit Corp! We're excited to
                    offer you a 30-day free trial of our services. During this
                    trial period, you'll have full access to all features with no
                    cost or commitment. This is the perfect opportunity to
                    experience the value we bring firsthand. If you have any
                    questions or need assistance, feel free to reach out to our
                    support team. We're here to help!
                  </p>
                  <span className="current-plan">Current Plan</span>
                </div>
              </div>

              {/* onClick={() => setSelectedPlan(plan)} */}
              {plans?.data?.prices?.map((plan) => (
                <div
                  key={plan?.id}
                  className={`col-md-4 mb-4 ${user?.subscription?.type === plan?.recurring?.interval
                    ? "currentPlan-box"
                    : ""
                    } ${plan?.recurring?.interval === "month" &&
                      user?.subscription?.type === "year"
                      ? "show-disable-card"
                      : ""
                    }`}
                >
                  <div className={`subscription-card`}>
                    <h1>
                      {plan?.recurring?.interval == "year" ? "365 Days Subscription (Annual Plan)" : "30 Days Subscription"}
                    </h1>

                    <span>${centsToDollar(plan?.unit_amount)}</span>

                    <p>
                      {plan?.recurring?.interval == "year" ? "Unlock a full year of premium access with maximum savings. Designed for long-term users and professionals, this plan ensures uninterrupted access, enhanced support, and exclusive yearly benefits. Enjoy peace of mind knowing your subscription covers you for 12 months — at the best value." : "Get full access to all premium features for a month with flexible renewal. Perfect for users who want to experience all the tools without a long-term commitment. Your subscription includes full feature access, cloud data sync, and customer support — all renewed every 30 days."}
                    </p>

                    <span className="current-plan">Current Plan</span>

                    <div className="d-flex h-100 align-items-end mt-4">
                      {user?.subscription?.type === plan?.recurring?.interval ? (
                        user?.subscription?.status == "cancelled" ? (
                          <button
                            className="btn btn-primary me-2"
                            disabled={true}
                            style={{ width: "fit-content" }}
                          >
                            Cancelled
                          </button>
                        ) : (

                          <button
                            className="btn btn-primary me-2"
                            data-bs-toggle="modal" href="#exampleModalToggle3" role="button"
                            style={{ width: "fit-content" }}
                          >
                            Cancel Subscription
                          </button>
                        )
                      ) : (
                        <button
                          className="btn btn-primary"
                          style={{ height: "45px" }}
                          disabled={plans.subBtnLoading}
                          onClick={(e) =>
                            handleCheckout(plan?.id, plan?.recurring?.interval)
                          }
                        >
                          {loadingPlanId === plan?.id ? (
                            <i
                              style={{ fontSize: "22px" }}
                              className="fa-solid fa-spinner fa-spin"
                            ></i>
                          ) : (
                            "Subscribe"
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="row mt-3">
              <div className="col-md-12 text-center">
                <span><strong>Subscription Till:</strong> {formatTime(user?.subscription?.end_date)}</span>
              </div>
            </div>
          </div>
        </div>

        <SubscriptionTable />
      </div>

      <div className="modal fade" data-bs-backdrop="static" id="exampleModalToggle3" aria-hidden="true" aria-labelledby="exampleModalToggleLabel2" tabindex="-1">
        <div className="modal-dialog modal-dialog-centered service-add-model">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="btn-close" id='close-btn-update-model-3' data-bs-dismiss="modal" aria-label="Close">
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>

            <div className="modal-body">
              <div className="container">
                <div className="row">
                  <div className="col-md-12 mt-4">
                    <div className="full-name-box justify-content-center">
                      <h1>Confirm subscription cancellation?</h1>
                    </div>
                    <div className="justify-content-center d-flex mb-4 mt-4">
                      <button type="button" disabled={plans?.cancelBtnLoading} className="btn btn-danger me-2" onClick={handleCancelSubscription}>
                        {plans?.cancelBtnLoading ? (
                          <i
                            style={{ fontSize: "22px" }}
                            className="fa-solid fa-spinner fa-spin"
                          ></i>
                        ) : (
                          "Yes"
                        )}
                      </button>

                      <button type="button" id='close-btn-update-model-3' data-bs-dismiss="modal" aria-label="Close" className="btn btn-secondary">
                        No
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Subscription;
